import { memo } from 'react';

import OverflowIconSVG from '@/assets/overflow-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IOverflowIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={OverflowIconSVG} {...props} />;

export const OverflowIcon = memo(IOverflowIcon) as typeof IOverflowIcon;
